import { useState } from 'react';
import '../App.css';
import USARouletteInfo from './USARouletteInfo';
import USATable from './USATable';

function USARoulette() {

    return (
        <div className='h-full flex'>
            <USARouletteInfo />
            <USATable />
        </div>
    );
}

export default USARoulette;